import styles from "./MountSide2C1.module.css";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import { Helmet } from "react-helmet";

//Reusable Section
import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import EditScreenItemHeaderDiv from "../../Reusables/EditScreenItemHeaderDiv";
import EditScreenHeaderInfoDiv from "../../Reusables/EditScreenHeaderInfoDiv";

import sample_1_1 from "../../../assets/images/edit_screen/Mount_Side2_Cut1/sample_1.png";

import sample_1_2 from "../../../assets/images/edit_screen/Mount_Side2_Cut1/sample_2.png";

import { useNavigate, useParams } from "react-router-dom";
import { createRef, useEffect, useRef, useState } from "react";
import useAxios from "../../Hooks/useAxios";
import PhotoSelection from "../PhotoSelection/PhotoSelection";
import MountSide2C1Reusable from "./MountSide2C1_Reusable";

import save_icon from "../../../assets/images/icons/save_icon.png";
import { scroller } from "react-scroll";
import GeneratePreviewFromEditState from "./MS2C1_GenerateSinglePreviewFromEditState";
import Loading from "../../Loading/Loading";

const MountSide2C1 = () => {
  const MAX_ITEMS = 50;
  const { product_id } = useParams();
  const childRefs = useRef(
    Array(MAX_ITEMS)
      .fill(null)
      .map(() => createRef())
  );
  let defaultStateSingleProduct = {
    imageRight: "",
    copied: false,
    imageLeft: "",
  };

  //new stuff
  const [showBottomPreviews, setShowBottomPreviews] = useState(false);
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(false);
  const [copyDetails, setCopyDetails] = useState([]);

  const [previewImages, setPreviewImages] = useState([]);
  const axios = useAxios();
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;

  const [showSelectionPopup, setShowSelectionPopup] = useState(false);

  const [imagesLeft, setImagesLeft] = useState(0);
  const [currentImageSelectionIndex, setCurrentPhotoSelectionIndex] =
    useState(-1);
  const [psk, setpsk] = useState(0);
  const [selectedImageSlot, setSelectedImageSlot] = useState(-1);
  let [editState, setEditState] = useState([]);
  const imageSelectionPopup = (index, count, selectedSlot = -1) => {
    setShowSelectionPopup(true);
    setImagesLeft(count);
    setCurrentPhotoSelectionIndex(index);
    setpsk(psk + 1);
    setSelectedImageSlot(selectedSlot);
    console.log("EDITSTATE BEFORE");
    console.log(editState);
  };
  const onPhotoSelectionEnd = (photo_url) => {
    setShowSelectionPopup(false);
    console.log("Photo Selection ends");
    console.log(photo_url.length);
    console.log(photo_url);
    const temp = JSON.parse(JSON.stringify(editState));
    console.log("States Before");
    console.log(temp);
    let picIdx = 0;
    temp[currentImageSelectionIndex].imageRight = photo_url[picIdx];

    console.log("States After");
    console.log(temp);
    setEditState(temp);
  };

  const changeEditState = (index, state) => {
    const temp = Array.from(editState);
    temp[index] = state;
    setEditState(temp);
  };
  const changePreviewImage = (index, newImage) => {
    console.log("chaning preview image");
    const temp = Array.from(previewImages);
    temp[index] = newImage;
    setPreviewImages(temp);
  };

  const confirmEdits = async () => {
    console.log("Confirm Edits. Send to server");
    console.log(editState);
    console.log(previewImages);
    const tempDetails = [];
    setLoading(true);
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    const tempPreviewImages = [];
    for (let i = 0; i < previewImages.length; i++) {
      console.log(childRefs);
      if (!previewImages[i]) {
        const file = await childRefs.current[i].current.changePreview(
          count === 1 ? null : i.toString()
        );
        if (!file) {
          setLoading(false);
          alert("Preview(s) was not generated");
          return;
        } else {
          console.log("Here's the file from parent");
          console.log(file);
          tempPreviewImages.push(file);
        }
      } else {
        tempPreviewImages.push(previewImages[i]);
      }
    }
    console.log("PREVIEW IMAGES HERE:");
    console.log(tempPreviewImages);

    const data = new FormData();
    data.append("design_details", JSON.stringify(tempDetails));
    data.append("copy_details", JSON.stringify(copyDetails));
    data.append("order_item_id", product_id);
    data.append("action", "CONFIRM");

    for (let i = 0; i < tempPreviewImages.length; i++) {
      const image = tempPreviewImages[i];
      console.log(image);
      data.append("preview_images_" + i, image, "image" + i + ".png");
    }

    axios
      .post(backend_base + "/design/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Posted THE EDIT DATA");
          console.log(res.data);
          // navigate("/design-box");
          navigate("/design-box/complete-submission", {
            state: {
              title: "二面台紙",
              subtitle: "1カット",
              count: count,
              address: "",
              item: item,
            },
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveToServer = () => {
    console.log("Send This to server");
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    let save_data = {
      design_details: JSON.stringify(tempDetails),
      order_item_id: product_id,
      preview_images: [],
      action: "SAVE",
      copy_details: JSON.stringify(copyDetails),
    };

    axios
      .post(backend_base + "/design/edit", save_data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("SAVED THE EDIT DATA");
          console.log(res.data);
          setSaveSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const [count, setCount] = useState(0);

  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + product_id)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Product With ID");
          console.log(res.data);
          setItem(res.data);
          setCount(res.data.quantity);
          let design = res.data.design;
          let status = design.design_status;
          console.log(design);
          console.log(design.design_status);
          if (status === "SAVED") {
            console.log(JSON.parse(design.design_details));
            setEditState(JSON.parse(design.design_details));
            setCopyDetails(JSON.parse(design.copy_details));
            let tempPreviewImages = [];
            for (let i = 0; i < res.data.quantity; i++) {
              tempPreviewImages.push(0);
            }
            setPreviewImages(tempPreviewImages);
          } else {
            let tempState = [];
            let tempPreviewImages = [];
            let tempCopyDetails = [];
            for (let i = 0; i < res.data.quantity; i++) {
              const temp = JSON.parse(
                JSON.stringify(defaultStateSingleProduct)
              );
              tempCopyDetails.push(i + 1);
              tempState.push(temp);
              tempPreviewImages.push(0);
            }
            console.log("Initial EDIT State:");
            console.log(tempState);
            setCopyDetails(tempCopyDetails);
            setEditState(tempState);
            setPreviewImages(tempPreviewImages);
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const generatePreviewsAtBottom = async () => {
    console.log("Setting the previews true because only editstate needed");
    setEditState(JSON.parse(JSON.stringify(editState)));
    setShowBottomPreviews(true);
  };

  const changeCopyDetails = async (details, index) => {
    console.log("CHANGE COPY DETAILS");
    console.log(index);
    console.log(details);
    const newDetails = JSON.parse(JSON.stringify(copyDetails));
    newDetails[index] = details;
    setCopyDetails(newDetails);
    let tempState = JSON.parse(JSON.stringify(editState[details - 1]));
    tempState.showPreview = false;
    tempState.copied = index !== details - 1;
    changeEditState(index, tempState);

    if (index === details - 1) {
      return;
    }

    const tempPreviewImages = Array.from(previewImages);
    console.log("COPY DETAILS");
    console.log(index);
    console.log(details);
    console.log(previewImages[details - 1]);
    const file = await childRefs.current[details - 1].current.changePreview();

    console.log("file from parent");
    console.log(file);
    if (!file) {
      // alert(" Preview was not generated");
      console.log("preview was not generated");
      return;
    } else {
      console.log("Here's the file from parent");
      console.log(file);
      tempPreviewImages[details - 1] = file;
      tempPreviewImages[index] = tempPreviewImages[details - 1];
    }

    console.log(tempPreviewImages);
    setPreviewImages(tempPreviewImages);
  };
  <Helmet>
    <script>
      {`(function(d) {
        var config = {
            kitId: 'tnx5lwp',
            scriptTimeout: 3000,
            async: true
          },
          h = d.documentElement,
          t = setTimeout(function() {
            h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
          }, config.scriptTimeout),
          tk = d.createElement("script"),
          f = false,
          s = d.getElementsByTagName("script")[0],
          a;
        h.className += " wf-loading";
        tk.src = 'https://use.typekit.net/' + config.kitId + '.js';
        tk.async = true;
        tk.onload = tk.onreadystatechange = function() {
          a = this.readyState;
          if (f || a && a != "complete" && a != "loaded") return;
          f = true;
          clearTimeout(t);
          try {
            Typekit.load(config)
          } catch (e) {}
        };
        s.parentNode.insertBefore(tk, s)
      })(document)`}
      ;
    </script>
  </Helmet>;
  return (
    <>
      {saveSuccess && (
        <div className={styles.SAVE_SUCCESS_MAIN}>
          <div className={styles.save_success_main_div}>
            <div className={styles.save_success_main_text}>
              一時保存しました
            </div>
            <ion-icon
              onClick={() => {
                setSaveSuccess(false);
              }}
              name="close"
            ></ion-icon>
          </div>
        </div>
      )}
      <Header />
      {showSelectionPopup && (
        <PhotoSelection
          skey={psk}
          count={imagesLeft}
          done={onPhotoSelectionEnd}
        />
      )}
      {!showSelectionPopup && (
        <div className={styles.wooden_square_edit_screen_main_div}>
          {count > 0 && (
            <div onClick={saveToServer} className={styles.save_box_main}>
              <img
                src={save_icon}
                className={styles.save_icon_image}
                alt="save"
              />
            </div>
          )}
          <DesignBoxNavigationCrumb active={3} />
          <EditScreenItemHeaderDiv
            title={"二面台紙"}
            subtitle={"1カット"}
            count={count}
            address={"会員様住所"}
            item={item}
          />
          <EditScreenHeaderInfoDiv
            lines={[
              "写真の選択が可能です。",
              "ギャラリーから写真を選択してください。",
            ]}
          />

          <div className={styles.title_hr}></div>

          <div className={styles.main_body_div}>
            <div className={styles.sample_div_main}>
              <div className={styles.sample_header}>台紙Sample</div>

              <div className={styles.sample_image_main_div}>
                <img
                  className={styles.sample_image}
                  src={sample_1_1}
                  alt="1_1"
                />

                <img
                  className={styles.sample_image}
                  src={sample_1_2}
                  alt="1_2"
                />
              </div>
            </div>
          </div>
          <div className={styles.reusable_main_div}>
            {[...Array(count)].map((_, index) => {
              const childRef = childRefs.current[index];
              return (
                <MountSide2C1Reusable
                  key={index}
                  ref={childRef}
                  index={index}
                  callback={changeEditState}
                  callbackPreviewChange={changePreviewImage}
                  state={editState[index]}
                  image_selection_popup={imageSelectionPopup}
                  //new stuff
                  generatePreviewsAtBottom={generatePreviewsAtBottom}
                  saveThisProduct={saveToServer}
                  changeCopyDetails={changeCopyDetails}
                  selectedCopyDetails={copyDetails[index]}
                  currentPageNumber={index + 1}
                  totalPageNumber={count}
                  preview_copied_image={previewImages[index]}
                />
              );
            })}
          </div>
          {count === 1 && (
            <div className={styles.confirm_edits}>
              <div className={styles.confirm_header}>
                上記の内容でデザイン決定しますか？
              </div>
              <div className={styles.confirm_button_section}>
                <button
                  onClick={() => {
                    scroller.scrollTo("編　集", {
                      spy: true,
                      smooth: true,
                      offset: -100,
                      duration: 500,
                    });
                  }}
                  className={styles.confirm_button_no}
                >
                  編集へ戻る
                </button>
                <button
                  onClick={() => {
                    confirmEdits();
                  }}
                  className={styles.confirm_button_yes}
                >
                  はい
                </button>
              </div>
            </div>
          )}
          {!showSelectionPopup && count > 1 && (
            <div className={styles.show_preview_bottom_button_main_div}>
              <div className={styles.hr_05}></div>
              <div className={styles.show_preview_bottom_button_blue}>
                全てのキーホルダーの写真の組み合わせを最終確認してください。
              </div>
              <div
                onClick={async () => {
                  await generatePreviewsAtBottom();
                  setShowBottomPreviews(true);
                }}
                className={styles.show_preview_bottom_button}
              >
                プレビュー
              </div>
              <div className={styles.hr_06}></div>
            </div>
          )}
          {!showSelectionPopup && showBottomPreviews && (
            <div className={styles.bottom_previews_main_wrapper}>
              <div className={styles.bottom_previews_main}>
                <div className={styles.bottom_previews_header}>最終確認</div>

                {editState.map((state, index) => {
                  return (
                    <div
                      key={index}
                      className={styles.bottom_preview_single_main}
                    >
                      <div
                        className={styles.header_number_2}
                        name={"editsection" + (index + 1)}
                      >
                        {index + 1 + "個目"}
                      </div>
                      <div className={styles.bottom_prev_img01}>
                        <GeneratePreviewFromEditState
                          state={state}
                          id={index.toString()}
                        />
                      </div>
                      <div
                        onClick={() => {
                          const elementName = "editsection" + (index + 1);

                          scroller.scrollTo(elementName, {
                            spy: true,
                            smooth: true,
                            offset: -100,
                            duration: 500,
                          });
                        }}
                        className={styles.scroll_tag99}
                      >
                        編集へ戻る
                      </div>
                    </div>
                  );
                })}
                <div className={styles.bottom_preview_text}>
                  上記の内容で最終決定しますか？
                </div>
                <div onClick={confirmEdits} className={styles.btm_final_btn}>
                  はい
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {loading && <Loading style={{ marginBottom: "50px" }} />}
      <Footer />
    </>
  );
};
export default MountSide2C1;
